import React from 'react'
import { TablePagination } from '@material-ui/core'

// Component
import CustomSearchComponent from 'StandardComponents/CustomSearchComponent/CustomSearchComponent'

// Style
import classes from './CustomedTableFooter.module.scss'

export default function CustomedTableFooter(props) {
  const {
    searchText,
    placeholder,
    role,
    status,
    rows = [],
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage
  } = props
  return (
    <React.Fragment>
      <div className={classes.root}>
        {role === 'Accounting Staff' || role === 'Accounting Supervisor' ? (
          <>
            {status === 'All Request' ? (
              <div className={classes.search}>
                <CustomSearchComponent
                  width={'200px'}
                  onChange={searchText}
                  placeholder={placeholder}
                />
              </div>
            ) : ('')}
          </>
        ) : (
          <div className={classes.search}>
            <CustomSearchComponent
              width={'200px'}
              onChange={searchText}
              placeholder={placeholder}
            />
          </div>
        )}
        <TablePagination
          className={classes.pagination}
          rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 500, 1000]}
          component='div'
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    </React.Fragment>
  )
}
